// ═══════════════════════════════════════════════════════════
// FOIA — GAB Field IDs  (real IDs — do not edit manually)
// App ID: uyw6d4mmv
// Generated by scripts/create_gab_tables.py
// ═══════════════════════════════════════════════════════════

export const FIELDS = {

  requests: {
    requestNumber:       '3l0bka2uw',
    status:              'd9qui8yc9',
    requestType:         'cpr2wautv',
    requesterId:         'x3insbsj7',
    assignedUserId:      'p9m3btizm',
    assignedDeptId:      'u6p49o9fi',
    subject:             'da713htpd',
    description:         'bxyrrdnbc',
    dateSubmitted:       'hu541shx7',
    dateAcknowledged:    'iv5j2unix',
    statutoryDeadline:   'm3e450kqj',
    extensionDeadline:   'usv316l59',
    extensionReason:     '72l60j0vm',
    clockPausedAt:       'hwrm8xu7w',
    clockPausedReason:   'p7rsit8u9',
    totalPausedDays:     'vcbuybcns',
    effectiveDeadline:   'n4nhsieg1',
    priority:            'xuouvgq50',
    requestChannel:      'kv2bqgxc5',
    isAnonymous:         'l4zor0jbg',
    tags:                'grjlxassc',
    jurisdictionId:      'rbzwjzc9k',
    workflowId:          'lia4ml2mg',
    invoiceId:           'avcfktfmn',
    totalFeesEstimated:  '0pcfthvgb',
    totalFeesCharged:    '4h77l1z48',
    totalFeesPaid:       'fa0rh98b3',
    internalNotes:       '2zsjby6pg',
    closedAt:            'ej63by7lz',
    closureReason:       'd67mpjapf',
    aiDeptSuggestion:    'ygl839e8b',
    aiComplexity:        'x97jca9dw',
    aiFlags:             'gh3m5yl0r',
  },

  requesters: {
    type:                'imuwftrmw',
    firstName:           'wl868pm5c',
    lastName:            '57fxli8g2',
    orgName:             'p8gym3hhd',
    email:               'mcfokdbqo',
    phone:               '4kzvhw2ie',
    address:             'qnjsa6lad',
    isVerified:          'e20gn348q',
    isRegistered:        'kr9zyyc3h',
    publicUserId:        'a2x295pg7',
    internalNotes:       'rmhfyjwqc',
  },

  documents: {
    requestId:                 'oahpbcrp2',
    fileName:                  'lauag3tf1',
    fileSize:                  '0opcmvnfh',
    mimeType:                  'y5eim5of7',
    storageUrl:                'dokcagkhi',   // |||DOCID|||{uuid}||| marker — original file
    redactedStorageUrl:        '2u2ivc9ld',   // |||DOCID|||{uuid}||| marker — redacted copy
    fileAttachmentId:          '2vkrrvn7y',   // ATTACHMENT field — original file attachmentId
    redactedFileAttachmentId:  'angtdlurc',   // ATTACHMENT field — redacted file attachmentId
    uploadedBy:                '32haxulna',
    uploadedAt:                'aztv4ap2x',
    source:                    'lou6b8dfl',
    isResponsive:              'b6gc0ch6c',
    responsiveClass:           'awp35rz3m',
    redactionStatus:           'gwlacx9q9',
    exemptionCodes:            'txurgcplo',
    isReleased:                '1gdrcmjcf',
    releasedAt:                'qizyyf0ai',
    aiResponsive:              'kdl8pezdq',
    aiConfidence:              '5h9lvist4',
    notes:                     'f1n6w0sj7',
  },

  redactions: {
    documentId:          'r4cc2i2pu',
    requestId:           'l8qantn4m',
    page:                'da215p9ef',
    coordinates:         'o0mcd8r6v',   // JSON {x,y,width,height}
    exemptionCode:       '6imy9xz4h',
    exemptionDesc:       'i77cb1bn4',
    redactedBy:          'axuruvhl0',
    redactedAt:          'xfhti195a',
    reviewedBy:          'hlau99z3c',
    reviewedAt:          'utt5vajxj',
    reviewStatus:        'h5jvqk4ib',
    notes:               '5yo5ckq7r',
  },

  tasks: {
    requestId:           '2404kv7db',
    type:                '1cm1q1iwl',
    title:               '97penlqlc',
    description:         'k46j5tu4a',
    assignedUserId:      '4ydjfguta',
    assignedDeptId:      'xdci9ta1e',
    dueDate:             'y1ev2ikzp',
    status:              'wkuxuu999',
    isBlocking:          't62uzxxkf',
    completedBy:         'vlokptqta',
    completedAt:         '8x74q4ono',
  },

  workflows: {
    jurisdictionId:      'oosyyhu85',
    name:                'x4dbq6n2q',
    description:         'n910xtkxf',
    isActive:            'puq8kywfj',
    isDefault:           '9ffynwxim',
  },

  workflowSteps: {
    workflowId:          'qq7q7scom',
    stepOrder:           'gybhknz2s',
    name:                'tcznercqa',
    taskType:            'c5br4errq',
    assignedRole:        'uki0d4sgn',
    daysToComplete:      'u7z9im5ao',
    isClockPausing:      'dwzyyb1a7',
    requiresApproval:    'zyvy6c2m4',
  },

  correspondence: {
    requestId:           'ram4zdfor',
    direction:           '6fovwjmlc',
    fromUserId:          'j9pjm9rh2',
    toAddresses:         'pl73nt2r4',   // JSON array of email addresses
    subject:             '0jk6l7w9v',
    body:                '0nt7xd0zl',
    templateId:          'c2i3nispe',
    isAutomated:         'x1s6mty1x',
    attachments:         'ek6mzd3kd',   // JSON array of |||DOCID||| markers
    sentAt:              'mnmrymyz9',
    readAt:              '5ipjupgyo',
  },

  corrTemplates: {
    jurisdictionId:      'j2plxtujm',
    name:                'nnr9uu6mt',
    trigger:             'l1mgd9iq4',
    subject:             'k5lu710vk',
    body:                'e9y7qbgsw',
    isActive:            'qm1b1qzse',
  },

  invoices: {
    requestId:           '1gvz8d6og',
    requesterId:         '7l07ho9zg',
    status:              'vsjp5z5ft',
    subtotal:            'nnqu3mw30',
    total:               'bc724dr0c',
    estimateSentAt:      'm1m3lwvjx',
    invoiceSentAt:       't61aluvkm',
    paidAt:              'cul74jted',
    paymentMethod:       'ditn0kj9y',
    stripePaymentId:     'ku7nowii7',
    pdfUrl:              '2waj9wouh',   // |||DOCID|||{uuid}||| marker
    notes:               'vd8vp9bhm',
  },

  invoiceItems: {
    invoiceId:           '8ptwpblv2',
    type:                '2ev6mvk28',
    description:         'imcw5qs0p',
    quantity:            '5zxzrkdn7',
    unitPrice:           'ckj6f4w0z',
    total:               'kgllnxy44',
    staffUserId:         '4sy0mcgaj',
    hours:               'dvyr5j3sk',
  },

  jurisdictions: {
    name:                'zcg7t6np3',
    state:               'ydh48fgsk',
    type:                '8ntt0yi4w',
    lawName:             'jig9ac56a',
    statutoryDays:       '8vtainh9s',
    extensionAllowed:    'aqqpljlqy',
    maxExtensionDays:    '81wm0dvk2',
    businessDaysOnly:    '6g1ywdhu0',
    acknowledgmentRequired: 'zskgciued',
    acknowledgmentDays:  '9kbcly9pf',
    feesAllowed:         '9smvvkzn8',
    logoUrl:             '5ubmhz654',
    primaryColor:        'cfbih2e4i',
    portalUrl:           'grt02kntn',
    contactInfo:         '6zyrh4l9z',
    alertThresholdDays:  '0qgbbkvql',
  },

  departments: {
    jurisdictionId:      'w547cdq4k',
    name:                '0q8sdpkdv',
    code:                'tzgrp8d8h',
    headUserId:          'ain52wzg2',
    email:               'b341xf174',
    isActive:            '5450cnm7k',
  },

  exemptionCodes: {
    jurisdictionId:      'blseyawl0',
    code:                '8malls3pe',
    title:               '16d9wcxqv',
    description:         'ttr3xsxrz',
    statutoryCitation:   'wq3gqdi90',
    isActive:            'davaez0rx',
  },

  holidays: {
    jurisdictionId:      '9ykiv44ae',
    date:                'wvxgalbef',
    name:                'bk1heca58',
    isRecurring:         'tfsvd98op',
  },

  clockPauses: {
    requestId:           'yj20jji98',
    pausedAt:            '2tx91uy0t',
    resumedAt:           '77a22nxau',
    reason:              'hgxfcxfuz',
    notes:               'des3r0qcy',
    pausedDays:          'oqq98jsg4',
    pausedBy:            'wxxqfm3ry',
  },

  publicUsers: {
    email:               'sa9qap35s',
    firstName:           '743a5wo5i',
    lastName:            '5aiedch5b',
    passwordHash:        'ot46twnge',
    isVerified:          'i28gvxl32',
    verificationToken:   'ejdm1gfx1',
    createdAt:           'op5uayfby',
    lastLoginAt:         'nux41oxez',
  },

  auditLog: {
    requestId:           '8dd7zvjdg',
    userId:              'jrsf7kzui',
    userEmail:           'in0wsqalm',
    action:              '6fj1k0l9d',
    details:             'ruz0n5901',
    ipAddress:           'ubbvnu45m',
    timestamp:           'gw33qaclr',
  },

  uploadTokens: {
    requestId:           'l9w6n6ts5',
    token:               'b6fep5l9w',
    label:               '9yvbwnouq',
    expiresAt:           'wn4653u59',
    isActive:            'itc9w46lp',
    createdBy:           'isrd9ob74',
    createdAt:           '92lymw4jg',
  },

  libraryDocuments: {
    title:               'tgjp1hlpb',
    description:         'cvjwtqyqz',
    category:            'd572yfsdf',
    fileName:            '8p8609ouz',
    fileSize:            'zbsr883ox',
    mimeType:            'wl84didj8',
    storageUrl:          'rlyg5894m',
    uploadedBy:          't1eqaot63',
    uploadedAt:          '81y0nz7r3',
    isPublished:         'h4q2rdkul',
  },

} as const;
